import styled from "styled-components";

export const StyledSection = styled.section`
  margin-block-end: 10em;
`